import MobileSearchField from './MobileSearchField';
import MobileSearchFieldContainer from './MobileSearchField.container';

export default MobileSearchFieldContainer(MobileSearchField);
